import axios from "axios";
import { environment } from "../../../environment";
const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/custodian-doc/documents/client/folder`
        : `https://middleware.uat.farther.com/custodian-doc/documents/client/folder`;
};
export default async function postCreateFolder(path, config) {
    await axios.post(url(), path, {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
            "Content-type": "application/json",
        },
    });
}
//# sourceMappingURL=postCreateFolder.js.map